function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClipboardJS from 'clipboard';
import { mapGetters } from 'vuex';
import { loginRegex } from '@/utils/format';
import sendVerifyCode from '@/mixins/SendVerifyCode';
import { uploader } from '@/utils/uploadCloud';
import { getToken } from '@/utils/auth';
import { userInfo, getCmsKeyApi, getCmsApi, editUserInfo, checkPasswordApi, site } from '@/api/user';
import helper from '@/libs/helper';
export default {
  name: 'Index',
  mixins: [sendVerifyCode],
  data: function data() {
    return {
      ruleForm: {
        name: '',
        uid: '',
        phone: '',
        avatar: '',
        email: '',
        password: ''
      },
      uPattern: '',
      textVal: '',
      password_confirm: '',
      verification_code: '',
      newPhone: '',
      newPassword: '',
      isEditPhone: true,
      isEditPassword: true,
      myHeaders: {
        authorization: 'Bearer ' + getToken()
      },
      sitedata: {},
      dsad: false,
      uploadSize: 2
    };
  },
  computed: _objectSpread({}, mapGetters(['userInfo'])),
  mounted: function mounted() {
    this.sitedata = JSON.parse(localStorage.getItem('sitedata'));
    var _loginRegex = loginRegex(this.sitedata.password_type, Number(this.sitedata.password_length)),
      val = _loginRegex.val,
      text = _loginRegex.text;
    this.textVal = text;
    this.uPattern = new RegExp(val);
    this.userInfoList();
  },
  methods: {
    regularFn: function regularFn() {
      if (!this.uPattern.test(this.newPassword)) return this.$message.error(this.textVal);
    },
    replacePwd: function replacePwd() {
      this.newPassword = '';
      this.password_confirm = '';
      this.isEditPassword = false;
    },
    copy: function copy() {
      var _this = this;
      this.$nextTick(function () {
        var clipboard = new ClipboardJS('.copy-data');
        clipboard.on('success', function () {
          _this.$message.success(_this.$t('setting.copytitle'));
          clipboard.destroy();
        });
        _this.$store.commit('app/SET_CLICK_TAB', false);
      });
    },
    cancelPwd: function cancelPwd() {
      this.ruleForm.password = '......';
      this.password_confirm = '';
      this.isEditPassword = true;
    },
    defaultPwd: function defaultPwd(data) {
      if (!data) {
        this.$set(this.ruleForm, 'password', '......');
      }
    },
    preserve: function preserve() {
      var _this2 = this;
      if (!this.isEditPassword) {
        this.confirmPwd();
      }
      if (!this.isEditPhone) {
        this.confirmBnt();
      }
      if (!this.password_confirm) {
        this.$delete(this.ruleForm, 'password');
      }
      this.ruleForm.password_confirm = this.password_confirm;
      this.ruleForm.password = this.newPassword;
      this.ruleForm.verification_code = this.verification_code;
      editUserInfo(this.ruleForm).then(function (res) {
        if (res.status != '200') {
          return false;
        }
        var userInfo = JSON.parse(JSON.stringify(_this2.$store.state.user.userInfo));
        userInfo.name = res.data.name;
        userInfo.avatar = res.data.avatar;
        userInfo.email = res.data.email;
        if (res.data.phone) {
          userInfo.phone = res.data.phone;
        }
        _this2.$store.commit('user/SET_USERINFO', userInfo);
        _this2.defaultPwd(_this2.ruleForm.password);
        if (res.status == '200') {
          _this2.$emit('isOk');
        }
      });
    },
    cancel: function cancel() {
      this.isEditPhone = true;
      this.isEditPassword = true;
      this.userInfoList();
      this.$emit('isOk');
    },
    confirmPwd: function confirmPwd() {
      var _this3 = this;
      if (!this.uPattern.test(this.newPassword)) return this.$message.error(this.textVal);
      if (!this.newPassword) return this.$message.error(this.$t('login.title2'));
      var data = {
        password: this.newPassword,
        password_confirm: this.password_confirm
      };
      checkPasswordApi(data).then(function (res) {
        _this3.ruleForm.password = _this3.newPassword;
        _this3.isEditPassword = true;
      });
    },
    getCode: function getCode() {
      this.getCmsKey();
    },
    getCmsKey: function getCmsKey() {
      var _this4 = this;
      getCmsKeyApi().then(function (res) {
        var cmsKey = res.data.key;
        var exp = helper.phoneReg;
        if (!_this4.newPhone) return _this4.$message.error(_this4.$t('login.title1'));
        if (!exp.test(_this4.newPhone)) {
          return _this4.$message.error(_this4.$t('login.title9'));
        }
        getCmsApi({
          phone: _this4.newPhone,
          key: cmsKey,
          types: 2
        }).then(function (res) {
          _this4.sendCode();
        }).catch(function () {
          _this4.getCmsKey();
        });
      });
    },
    confirmBnt: function confirmBnt() {
      var exp = helper.phoneReg;
      if (!this.verification_code || !this.newPhone) {
        return this.$message.error(this.$t('login.rules'));
      }
      if (!exp.test(this.newPhone)) {
        return this.$message.error(this.$t('login.title9'));
      }
      if (!/^\d{6}$/.test(this.verification_code)) {
        return this.$message.error(this.$t('login.title5'));
      }
      this.ruleForm.phone = this.newPhone;
      this.isEditPhone = true;
    },
    userInfoList: function userInfoList() {
      var _this5 = this;
      site().then(function (res) {
        _this5.sitedata = res.data;
        localStorage.setItem('sitedata', JSON.stringify(_this5.sitedata));
      });
      userInfo().then(function (res) {
        _this5.ruleForm = res.data;
        _this5.defaultPwd(res.data.password);
      });
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this6 = this;
      var file = params.file;
      var options = {
        way: 1,
        relation_type: '',
        relation_id: 0,
        eid: 0
      };
      uploader(file, 1, 2, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this6.ruleForm.avatar = res.url;
          _this6.userInfo.card.avatar = res.url;
        }
      });
    },
    handleRemove: function handleRemove() {
      this.ruleForm.avatar = '';
    }
  }
};